export default __webpack_public_path__ + "static/media/02.f38be9d7.png";